export default __webpack_public_path__ + "static/media/logo.518d5dd0.png";